import { AuthGuard } from '../auth/AuthGuard';
import { ClientTiersProvider } from '../auth/ClientTiersProvider';
import { AccountContextProvider } from '../auth/AccountContextProvider';
import { ClientLayout } from './ClientLayout';

export function AuthLayout() {
  return (
    <AuthGuard>
      <ClientTiersProvider>
        {/* #16306 — mounts INSIDE ClientTiersProvider: it consumes the caller's own
            accountId from that context rather than adding a second /client-it/me hop. */}
        <AccountContextProvider>
          <ClientLayout />
        </AccountContextProvider>
      </ClientTiersProvider>
    </AuthGuard>
  );
}
